import { jsx as f, jsxs as e } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.es.js";
import { SvgIcon } from "@mui/material";
function n(C) {
  return /* @__PURE__ */ f(SvgIcon, { ...C, children: /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ f("path", { d: "M4.02014 14C2.91614 14 2.01514 13.104 2.01514 12C2.01514 10.896 2.90513 10 4.01013 10H4.02014C5.12414 10 6.02014 10.896 6.02014 12C6.02014 13.104 5.12514 14 4.02014 14Z", fill: "#00BB8C" }),
    /* @__PURE__ */ f("path", { d: "M20.0201 14C18.9161 14 18.0151 13.104 18.0151 12C18.0151 10.896 18.9051 10 20.0101 10H20.0201C21.1241 10 22.0201 10.896 22.0201 12C22.0201 13.104 21.1251 14 20.0201 14Z", fill: "#00CC99" }),
    /* @__PURE__ */ f("path", { d: "M12.0201 14C10.9161 14 10.0151 13.104 10.0151 12C10.0151 10.896 10.9051 10 12.0101 10H12.0201C13.1241 10 14.0201 10.896 14.0201 12C14.0201 13.104 13.1251 14 12.0201 14Z", fill: "#171F36" })
  ] }) });
}
export {
  n as MoreHorizontalDuotone
};
//# sourceMappingURL=more-horizontal-duotone.es.es.js.map
